import React from "react";
import {
  MdChevronLeft,
  MdChevronRight,
  MdAdd,
  MdCalendarToday,
  MdArrowDropDown,
  MdRefresh,
  MdCheckBox,
} from "react-icons/md";
import { Switch, Tooltip } from "@mui/material";
import { CalendarHeaderProps } from "../types";
import * as S from "../styles";

const CalendarHeader: React.FC<CalendarHeaderProps> = ({
  currentDate,
  viewMode,
  onViewModeChange,
  onNavigate,
  onNewEvent,
  onNewTask,
  onTitleClick,
  onRefresh,
  isRefreshing,
  syncEnabled,
  onSyncChange,
}) => {
  return (
    <S.HeaderContainer>
      <S.HeaderLeft>
        <Tooltip title="Voltar">
          <S.NavigationButton onClick={() => onNavigate("prev")}>
            <MdChevronLeft />
          </S.NavigationButton>
        </Tooltip>
        <Tooltip title="Avançar">
          <S.NavigationButton onClick={() => onNavigate("next")}>
            <MdChevronRight />
          </S.NavigationButton>
        </Tooltip>
        <S.TodayButton onClick={() => onNavigate("today")}>Hoje</S.TodayButton>
      </S.HeaderLeft>

      <S.HeaderCenter>
        <S.HeaderTitle
          onClick={onTitleClick}
          style={{ cursor: onTitleClick ? "pointer" : "default" }}
        >
          {currentDate
            .toLocaleDateString("pt-BR", {
              month: "long",
              year: "numeric",
            })
            .replace(/^\w/, (c) => c.toUpperCase())}
          {onTitleClick && (
            <MdArrowDropDown
              style={{ verticalAlign: "middle", marginLeft: 2 }}
            />
          )}
        </S.HeaderTitle>

        <S.SyncToggle>
          <MdCalendarToday />
          <span>Sincronizar tarefa no calendário</span>
          <Switch
            size="small"
            checked={syncEnabled}
            onChange={(e) => onSyncChange(e.target.checked)}
            sx={{
              "& .MuiSwitch-switchBase.Mui-checked": {
                color: "#2d5bff",
              },
              "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                backgroundColor: "#2d5bff",
              },
            }}
          />
        </S.SyncToggle>
      </S.HeaderCenter>

      <S.HeaderRight>
        <S.ViewModeToggle>
          <S.ViewModeButton
            $active={viewMode === "day"}
            onClick={() => onViewModeChange("day")}
            data-short="Dia"
          >
            <span>Dia</span>
          </S.ViewModeButton>
          <S.ViewModeButton
            $active={viewMode === "workWeek"}
            onClick={() => onViewModeChange("workWeek")}
            data-short="Úteis"
          >
            <span>Semana de trabalho</span>
          </S.ViewModeButton>
          <S.ViewModeButton
            $active={viewMode === "week"}
            onClick={() => onViewModeChange("week")}
            data-short="Semana"
          >
            <span>Semana</span>
          </S.ViewModeButton>
        </S.ViewModeToggle>

        {onRefresh && (
          <Tooltip title="Atualizar">
            <S.RefreshButton onClick={onRefresh} $spinning={isRefreshing}>
              <MdRefresh />
            </S.RefreshButton>
          </Tooltip>
        )}

        {onNewTask && (
          <S.NewTaskButton onClick={onNewTask}>
            <MdCheckBox />
            <span>Nova tarefa</span>
          </S.NewTaskButton>
        )}

        <S.NewEventButton onClick={onNewEvent}>
          <MdAdd />
          <span>Novo evento</span>
        </S.NewEventButton>
      </S.HeaderRight>
    </S.HeaderContainer>
  );
};

export default CalendarHeader;
